"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _date = require("../../utils/date");

var _Button = _interopRequireDefault(require("../Button"));

var _iconsReact = require("../../icons-react");

var SearcherCollapsed = function SearcherCollapsed(props) {
  var searchParams = props.searchParams,
      onClick = props.onClick;
  var start_date = searchParams.start_date,
      nights = searchParams.nights,
      adults = searchParams.adults,
      _searchParams$kids = searchParams.kids,
      kids = _searchParams$kids === void 0 ? [] : _searchParams$kids,
      departure = searchParams.departure;
  var startDate = (0, _date.formatDate)(start_date, 'dd MMM');
  var nightsRange = Object.values(nights).join('-');
  return /*#__PURE__*/_react["default"].createElement(Wrapper, null, /*#__PURE__*/_react["default"].createElement(SearchParams, null, "\u0441 ", startDate, " \u043D\u0430 ", nightsRange, " \u043D\u043E\u0447\u0435\u0439, ", adults, " ", /*#__PURE__*/_react["default"].createElement(AdultIcon, null), kids.length && " + ".concat(kids.length, " "), kids.length && /*#__PURE__*/_react["default"].createElement(KidIcon, null), " \xB7 \u0432\u044B\u043B\u0435\u0442 ", departure), /*#__PURE__*/_react["default"].createElement(StyledButton, {
    functional: true,
    onClick: onClick
  }, "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B \u043F\u043E\u0438\u0441\u043A\u0430"));
};

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "SearcherCollapsed__Wrapper",
  componentId: "sc-yq90nz-0"
})(["background-color:#f3f2e8;padding:8px;border-radius:4px;"]);

var SearchParams = _styledComponents["default"].span.withConfig({
  displayName: "SearcherCollapsed__SearchParams",
  componentId: "sc-yq90nz-1"
})(["font-weight:bold;margin-right:16px;"]);

var AdultIcon = (0, _styledComponents["default"])(_iconsReact.Male).withConfig({
  displayName: "SearcherCollapsed__AdultIcon",
  componentId: "sc-yq90nz-2"
})(["width:7px;height:15px;margin-bottom:-3px;"]);
var KidIcon = (0, _styledComponents["default"])(_iconsReact.Boy).withConfig({
  displayName: "SearcherCollapsed__KidIcon",
  componentId: "sc-yq90nz-3"
})(["width:8px;height:16px;margin-bottom:-2px;"]);
var StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "SearcherCollapsed__StyledButton",
  componentId: "sc-yq90nz-4"
})(["color:#007aff;"]);
var _default = SearcherCollapsed;
exports["default"] = _default;